import { StatesModule, Transition } from '@uirouter/angular';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { BillingHeaderComponent, IBillingModuleModel } from '@fi-app/billing/billing-header/billing-header.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { AppTextService } from '@fi-shared/app-text';
import { BillingCentralListComponent } from '@fi-app/billing/billing-central/billing-central-list/billing-central-list.component';
import { BillingCentralViewComponent } from '@fi-app/billing/billing-central/billing-central-view/billing-central-view.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { BillingService } from '@fi-app/billing/billing.service';
import { BillingCentralEditComponent } from '@fi-app/billing/billing-central/billing-central-edit/billing-central-edit.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { BillingUnitListComponent } from '@fi-app/billing/billing-unit/billing-unit-list/billing-unit-list.component';
import { BillingUnitViewComponent } from '@fi-app/billing/billing-unit/billing-unit-view/billing-unit-view.component';
import { BillingUnitEditComponent } from '@fi-app/billing/billing-unit/billing-unit-edit/billing-unit-edit.component';
import { BillingPaymentListComponent } from '@fi-app/billing/billing-payment/billing-payment-list/billing-payment-list.component';
import { BusinessUnitInvoiceInformationViewComponent } from '@fi-app/billing/billing-payment/business-unit-invoice-information-view/business-unit-invoice-information-view.component';
import { BusinessUnitInvoiceInformationEditComponent } from '@fi-app/billing/billing-payment/business-unit-invoice-information-edit/business-unit-invoice-information-edit.component';
import { BusinessUnitCreditCardInformationViewComponent } from '@fi-app/billing/billing-payment/business-unit-credit-card-information-view/business-unit-credit-card-information-view.component';
import { BusinessUnitCreditCardInformationEditComponent } from '@fi-app/billing/billing-payment/business-unit-credit-card-information-edit/business-unit-credit-card-information-edit.component';
import { BillingCompanyInformationListComponent } from '@fi-app/billing/billing-company-information/billing-company-information-list/billing-company-information-list.component';
import { BillingCompanyInformationViewComponent } from '@fi-app/billing/billing-company-information/billing-company-information-view/billing-company-information-view.component';
import { BillingCompanyInformationEditComponent } from '@fi-app/billing/billing-company-information/billing-company-information-edit/billing-company-information-edit.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

const BillingState: Ng2StateDeclaration = {
    name: FiStateNames.Billing._name,
    url: '/Billing',
    abstract: true,
    views: {
        '@': {
            component: BillingHeaderComponent,
        },
    },
    resolve: {
        billingModuleModel: BillingBillingModuleModel,
        pageTitle: [PageTitleService, BillingPageTitle],
    },
};
export function BillingBillingModuleModel() {
    return {
        SelectedTabIndex: 0,
        ListData: null,
    };
}
export function BillingPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitle('Billing');
}

const BillingCentralState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Central._name,
    url: '/Central',
    abstract: true,
    resolve: {
        pageTitle: [PageTitleService, AppTextService, BillingCentralPageTitle],
    },
};
export function BillingCentralPageTitle(ccmPageTitle: PageTitleService, appTextService: AppTextService) {
    return ccmPageTitle.setTitle(appTextService.get('billing.billing_central'));
}

const BillingCentralListState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Central.List,
    url: '/',
    views: {
        '@GlobalSettings.Billing': {
            component: BillingCentralListComponent,
        },
    },
    resolve: {
        billingModuleModel: ['billingModuleModel', BillingListBillingModuleModel],
    },
};
export function BillingListBillingModuleModel(billingModuleModel: IBillingModuleModel) {
    return billingModuleModel;
}

const BillingCentralViewState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Central.View,
    url: '/:ModuleType',
    views: {
        '@': {
            component: BillingCentralViewComponent,
        },
    },
    resolve: {
        businessUnitModule: [FiStateService, '$transition$', BillingService, BillingCentralBusinessUnitModule],
    },
};
export function BillingCentralBusinessUnitModule(
    stateService: FiStateService,
    transition: Transition,
    BillingService: BillingService,
) {
    return BillingService.GetCentralBillingModule(stateService.getParams(transition).ModuleType);
}

const BillingCentralEditState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Central.Edit,
    url: '/:ModuleType/Edit',
    views: {
        '@': {
            component: BillingCentralEditComponent,
        },
    },
    resolve: {
        businessUnitModule: [FiStateService, Transition, BillingService, BillingCentralBusinessUnitModule],
    },
};

const BillingUnitState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Unit._name,
    url: '/Unit',
    abstract: true,
    resolve: {
        pageTitle: [PageTitleService, AppTextService, BillingUnitPageTitle],
    },
};
export function BillingUnitPageTitle(ccmPageTitle: PageTitleService, appText: AppTextService) {
    return ccmPageTitle.setTitle(appText.get('billing.billing_unit'));
}

const BillingUnitListState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Unit.List,
    url: '/',
    views: {
        '@GlobalSettings.Billing': {
            component: BillingUnitListComponent,
        },
    },
    resolve: {
        billingModuleModel: ['billingModuleModel', BillingListBillingModuleModel],
    },
};

const BillingUnitViewState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Unit.View,
    url: '/:ModuleType/:UnitId',
    views: {
        '@': {
            component: BillingUnitViewComponent,
        },
    },
    resolve: {
        unitModule: [FiStateService, Transition, BillingService, BillingUnitModule],
    },
};
export function BillingUnitModule(
    stateService: FiStateService,
    transition: Transition,
    BillingService: BillingService,
) {
    return BillingService.GetUnitBillingModule(
        stateService.getParams(transition).ModuleType,
        stateService.getParams(transition).UnitId,
    );
}

const BillingUnitEditState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Unit.Edit,
    url: '/:ModuleType/:UnitId/Edit',
    views: {
        '@': {
            component: BillingUnitEditComponent,
        },
    },
    resolve: {
        unitModule: [FiStateService, Transition, BillingService, BillingUnitModule],
    },
};

const BillingPaymentState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment._name,
    url: '/Payment',
    abstract: true,
    resolve: {
        pageTitle: [PageTitleService, AppTextService, BillingPaymentPageTitle],
    },
};
export function BillingPaymentPageTitle(ccmPageTitle: PageTitleService, appText: AppTextService) {
    return ccmPageTitle.setTitle(appText.get('billing.billing_payment'));
}

const BillingPaymentListState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment.List,
    url: '/',
    views: {
        '@GlobalSettings.Billing': {
            component: BillingPaymentListComponent,
        },
    },
    resolve: {
        billingModuleModel: ['billingModuleModel', BillingListBillingModuleModel],
    },
};

const BillingPaymentInvoiceInformationRootState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment.InvoiceInformation._name,
    url: '/InvoiceInformation',
    abstract: true,
};

const BillingPaymentInvoiceInformationState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment.InvoiceInformation.View,
    url: '/View',
    views: {
        '@': {
            component: BusinessUnitInvoiceInformationViewComponent,
        },
    },
    resolve: {
        invoiceInformation: [FiStateService, Transition, BillingService, BillingPaymentInvoiceInformation],
    },
};
export function BillingPaymentInvoiceInformation(
    stateService: FiStateService,
    transition: Transition,
    BillingService: BillingService,
) {
    return BillingService.GetCentralBillingPaymentInfo();
}

const BillingPaymentInvoiceInformationEdit: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment.InvoiceInformation.Edit,
    url: '/Edit',
    views: {
        '@': {
            component: BusinessUnitInvoiceInformationEditComponent,
        },
    },
    resolve: {
        invoiceInformation: [FiStateService, Transition, BillingService, BillingPaymentInvoiceInformation],
    },
};

const BillingPaymentCreditCardInformationRootState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment.CreditCardInformation._name,
    url: '/CreditCardInformation',
    abstract: true,
};

const BillingPaymentCreditCardInformationState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment.CreditCardInformation.View,
    url: '/:BusinessUnitId/View',
    views: {
        '@': {
            component: BusinessUnitCreditCardInformationViewComponent,
        },
    },
    resolve: {
        creditCardInformation: [FiStateService, Transition, BillingService, BillingPaymentCreditCardInformation],
    },
};
export function BillingPaymentCreditCardInformation(
    stateService: FiStateService,
    transition: Transition,
    BillingService: BillingService,
) {
    return BillingService.GetCreditCardInformation(stateService.getParams(transition).BusinessUnitId);
}

const BillingPaymentCreditCardInformationEditState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.Payment.CreditCardInformation.Edit,
    url: '/:BusinessUnitId/Edit',
    views: {
        '@': {
            component: BusinessUnitCreditCardInformationEditComponent,
        },
    },
    resolve: {
        creditCardInformation: [FiStateService, Transition, BillingService, BillingPaymentCreditCardInformation],
    },
};

const BillingCompanyInformationState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.CompanyInformation._name,
    url: '/CompanyInformation',
    abstract: true,
    resolve: {
        pageTitle: [PageTitleService, AppTextService, BillingCompanyInformationPageTitle],
    },
};
export function BillingCompanyInformationPageTitle(ccmPageTitle: PageTitleService, appText: AppTextService) {
    return ccmPageTitle.setTitle(appText.get('billing.company_information'));
}

const BillingCompanyInformationListState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.CompanyInformation.List,
    url: '/',
    views: {
        '@GlobalSettings.Billing': {
            component: BillingCompanyInformationListComponent,
        },
    },
    resolve: {
        billingModuleModel: ['billingModuleModel', BillingListBillingModuleModel],
    },
};

const BillingCompanyInformationViewState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.CompanyInformation.View,
    url: '/:BusinessUnitId',
    views: {
        '@': {
            component: BillingCompanyInformationViewComponent,
        },
    },
    resolve: {
        businessUnitCompanyInformation: [
            FiStateService,
            Transition,
            BillingService,
            BillingBusinessUnitCompanyInformation,
        ],
    },
};
export function BillingBusinessUnitCompanyInformation(
    stateService: FiStateService,
    transition: Transition,
    BillingService: BillingService,
) {
    return BillingService.GetBusinessUnitCompanyInformation(stateService.getParams(transition).BusinessUnitId);
}

const BillingCompanyInformationEditState: Ng2StateDeclaration = {
    name: FiStateNames.Billing.CompanyInformation.Edit,
    url: '/:BusinessUnitId/Edit',
    views: {
        '@': {
            component: BillingCompanyInformationEditComponent,
        },
    },
    resolve: {
        businessUnitCompanyInformation: [
            FiStateService,
            Transition,
            BillingService,
            BillingBusinessUnitCompanyInformation,
        ],
    },
};

export const BillingStates: StatesModule = {
    states: [
        BillingState,
        BillingCentralState,
        BillingCentralListState,
        BillingCentralViewState,
        BillingCentralEditState,
        BillingUnitState,
        BillingUnitListState,
        BillingUnitViewState,
        BillingUnitEditState,
        BillingPaymentState,
        BillingPaymentListState,
        BillingPaymentInvoiceInformationState,
        BillingPaymentInvoiceInformationEdit,
        BillingPaymentCreditCardInformationRootState,
        BillingPaymentCreditCardInformationState,
        BillingPaymentCreditCardInformationEditState,
        BillingPaymentInvoiceInformationRootState,
        BillingCompanyInformationState,
        BillingCompanyInformationListState,
        BillingCompanyInformationViewState,
        BillingCompanyInformationEditState,
    ],
};

export function registerBillingStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Billing._name], {
        SettingType: [ApplicationSettingsType.BillingLocal],
        AccessType: AccessRightType.Admin,
    });

    stateAccessCheckService.registerStateRules(
        [FiStateNames.Billing.Central.List, FiStateNames.Billing.Central.View, FiStateNames.Billing.Central.Edit],
        {
            SettingType: [ApplicationSettingsType.BillingCentral],
            AccessType: AccessRightType.Admin,
        },
    );
}
